import React from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Typography, IconButton, Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CriteriosImpactoContenido from "./CriteriosImpactoContenido";

const DetalleImpactoModal = ({ open, onClose, token, idUsuario, normativa, esAdmin = false, onGuardado }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ pr: 6 }}>
        <Typography variant="h6" component="div" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
          Criterios de impacto
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25, wordBreak: "break-word" }}>
          {normativa?.nombre}
        </Typography>
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 2, minHeight: 300 }}>
        {open && normativa?.id && (
          <CriteriosImpactoContenido
            token={token}
            idUsuario={idUsuario}
            idNormativa={normativa.id}
            esAdmin={esAdmin}
            onGuardado={onGuardado}
          />
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DetalleImpactoModal;